/** Merchant conventions for hierarchy moves, not facts about shelves — overridable per merchant. */
export interface HierarchyMoveRules {
  minFacingsPerShelf: number;
  roundTripFloorShare: number;
  fillFloorShare: number;
  fillDropTolerancePts: number;
  seamPass: "off" | "facings-neutral" | "on";
}

export const DEFAULT_HIERARCHY_MOVE_RULES: HierarchyMoveRules = {
  minFacingsPerShelf: 2,
  roundTripFloorShare: 530 / 556,
  fillFloorShare: 0.989,
  fillDropTolerancePts: 0.5,
  seamPass: "on",
};
